import CircleIcon from '@mui/icons-material/Circle';
import { Grid, Divider } from '@mui/material';
import { FaBriefcase, FaCheckCircle } from 'react-icons/fa';
import { IJob, IWorkAssignment } from 'wisestep-api';
import {
  WsTypography,
  WsTypoVariants,
  WsBadge,
  WsBadgeSize,
  WsBadgetype,
  timeSince,
  WsTypoColors,
} from 'wisestep-base';

import { onRecruiterNameClick } from '../../../../features/candidateLayout/utils/CandidateHelper';
import WsLink from '../../../../features/teams/components/WsLink';
import { useJobCRMContext } from '../../context';

const getWorkAssignmentStatus = (workAssignment: IWorkAssignment | null, job: IJob | null) => {
  const isJobToBeAccepted =
    !job?.isClosedForAssigningRecruiters &&
    workAssignment?.assignedBy &&
    !workAssignment?.isAccepted &&
    !workAssignment?.isClosed;

  return workAssignment?.isAccepted
    ? `Job is accepted`
    : isJobToBeAccepted
    ? `Job not accepted`
    : `Job not assigned`;
};

const JobCRMLeftHeader = () => {
  const { workAssignment, job } = useJobCRMContext();
  return (
    <Grid item display="flex" direction="column" rowGap={1}>
      <Grid item display="flex" columnGap={2} alignItems="center">
        <WsTypography bold variant={WsTypoVariants.TITLE}>
          {job?.title ?? ''}
        </WsTypography>
        <WsTypography bold>{job?.jobCode}</WsTypography>
        <CircleIcon color="secondary" sx={{ fontSize: 8 }} />
        <WsLink
          to={`/client-details?clientId=${job?.clientId}&isChild=true`}
          sx={{
            fontSize: 16,
            '&:hover': {
              textDecoration: 'none',
            },
          }}
        >
          {job?.companyName}
        </WsLink>
        <CircleIcon color="secondary" sx={{ fontSize: 8 }} />
        <WsBadge
          label={!job?.isClosedForAssigningRecruiters ? 'Open' : 'Closed'}
          badgeType={
            !job?.isClosedForAssigningRecruiters ? WsBadgetype.SUCCESS : WsBadgetype.FAILED
          }
          icon={<FaBriefcase size={16} />}
          startIcon
          badgeSize={WsBadgeSize.LARGE}
        />
        <CircleIcon color="secondary" sx={{ fontSize: 8 }} />
        <WsBadge
          label={getWorkAssignmentStatus(workAssignment, job)}
          badgeType={workAssignment?.isAccepted ? WsBadgetype.SUCCESS : WsBadgetype.PENDING}
          icon={<FaCheckCircle size={16} />}
          startIcon
          badgeSize={WsBadgeSize.LARGE}
        />
      </Grid>
      <Grid item display="flex" columnGap={1} alignItems="center">
        <WsTypography opacity>
          {`Job Created on ${timeSince(job?.createdOn?.toString() ?? '')} by `}
        </WsTypography>

        <WsTypography
          onClick={() => onRecruiterNameClick(job?.createdBy ?? '')}
          cursor="pointer"
          color={WsTypoColors.PRIMARY750}
        >
          {job?.createdBy}
        </WsTypography>

        <Divider orientation="vertical" flexItem sx={{ height: 24 }} />

        <WsTypography opacity>
          {`Last updated on ${timeSince(job?.modifiedOn?.toString() ?? '')} by `}
        </WsTypography>

        <WsTypography
          onClick={() => onRecruiterNameClick(job?.modifiedBy ?? '')}
          cursor="pointer"
          color={WsTypoColors.PRIMARY750}
        >
          {job?.modifiedBy}
        </WsTypography>
      </Grid>
    </Grid>
  );
};

export default JobCRMLeftHeader;
